import { useState } from 'react';
import { ApiError } from '../api/client.js';
import styles from './Rewards.module.css';

export const QUERY_KEY = ['tech-time', 'grades'] as const;

/** Human-readable error detail (includes the API code + status for reporting). */
export function describeError(err: unknown): string {
  if (err instanceof ApiError) {
    return `${err.code} (${err.status})${err.message ? ` — ${err.message}` : ''}`;
  }
  return err instanceof Error ? err.message : 'unknown error';
}

/** Small "+ add" control that reveals a text input, submits on Enter/button. */
export function AddInline(props: {
  placeholder: string;
  label: string;
  testId: string;
  pending: boolean;
  onAdd: (value: string) => void;
}) {
  const [value, setValue] = useState('');
  const submit = () => {
    const v = value.trim();
    if (!v) return;
    props.onAdd(v);
    setValue('');
  };
  return (
    <form
      className={styles.addInline}
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <input
        className={styles.addInput}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={props.placeholder}
        aria-label={props.placeholder}
        data-testid={`${props.testId}-input`}
      />
      <button
        type="submit"
        className={styles.addBtn}
        disabled={props.pending || value.trim().length === 0}
        data-testid={props.testId}
      >
        {props.label}
      </button>
    </form>
  );
}

/** Inline rename: shows current value, editable, commits on blur/Enter. */
export function RenameInline(props: { current: string; onRename: (name: string) => void }) {
  const [value, setValue] = useState(props.current);
  const commit = () => {
    const v = value.trim();
    if (v && v !== props.current) props.onRename(v);
  };
  return (
    <input
      className={styles.renameInput}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') (e.target as HTMLInputElement).blur();
      }}
      aria-label="Rename"
    />
  );
}
